module.exports = __webpack_public_path__ + "img/rupeeIcon.03c4603f.svg";